import {
  ScriptStepPermissionDef,
  ScriptStepSubjectDef,
} from 'xm-constants/scriptStepPermissionDef';
import { getAllUsersEntity } from 'actions/permissionSearch/permissionSearch';
import { getSubjectDisplayName } from 'utils/permissions/permissions';

const makePermissionEntry = (step, subject, access) => ({
  displayName: getSubjectDisplayName(subject),
  scriptStep: step,
  shareType: access,
  subject: {
    id: subject.id,
  },
  subjectType: subject.recipientType,
});

const accessOrder = [
  ScriptStepPermissionDef.owner,
  ScriptStepPermissionDef.canEdit,
  ScriptStepPermissionDef.canUse,
  ScriptStepPermissionDef.notShared,
];
const subjectTypeOrder = [
  ScriptStepSubjectDef.allUsers,
  ScriptStepSubjectDef.role,
  ScriptStepSubjectDef.group,
  ScriptStepSubjectDef.person,
];

export function permissionSort(permA, permB) {
  // Then, sorting by share type
  let order =
    accessOrder.indexOf(permA.shareType) - accessOrder.indexOf(permB.shareType);

  if (order === 0) {
    // Then, sorting by subject type
    order =
      subjectTypeOrder.indexOf(permA.subjectType) -
      subjectTypeOrder.indexOf(permB.subjectType);
  }

  if (order === 0) {
    // Then, sorting by name
    order = permA.displayName.localeCompare(permB.displayName);
  }

  return order;
}

export function fromApiSchema({ step, intl }) {
  const augmentedPermissions = [...step.permitted.data];
  if (step.owner) {
    augmentedPermissions.unshift(
      makePermissionEntry(step, step.owner, ScriptStepPermissionDef.owner),
    );
  }

  if (step.accessibleByAll !== ScriptStepPermissionDef.notShared) {
    augmentedPermissions.push(
      makePermissionEntry(
        step,
        getAllUsersEntity({ intl }),
        step.accessibleByAll,
      ),
    );
  }

  return {
    step,
    owner: step.owner,
    permitted: augmentedPermissions.sort(permissionSort),
  };
}

export function toOwnerApiSchema(formData) {
  const apiSchema = { id: formData.step.id };
  const owner = formData.permitted.find(
    p => p.shareType === ScriptStepPermissionDef.owner,
  );

  if (formData.owner?.id !== owner?.subject?.id) {
    apiSchema.owner = formData.owner;
  }

  return apiSchema;
}

export function toApiSchema(formData) {
  const apiSchema = toOwnerApiSchema(formData);

  const allUserPermission = formData.permitted.find(
    p => p.subjectType === ScriptStepSubjectDef.allUsers,
  );

  apiSchema.accessibleByAll =
    allUserPermission !== undefined
      ? allUserPermission.shareType
      : ScriptStepPermissionDef.notShared;

  apiSchema.permitted = formData.permitted.filter(
    p =>
      p.shareType !== ScriptStepPermissionDef.owner &&
      p.subjectType !== ScriptStepSubjectDef.allUsers,
  );

  return apiSchema;
}
